"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SystemCheckPageFooter = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _underscore = require("underscore");
var _constants = require("../../../constants");
var _ = require("../..");
var _logger = require("@studio/logger");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LOG = new _logger.StudioLogger('SystemCheckPageFooter');
/**
 * SystemCheckPageFooter component renders the footer for the System Check page with navigation and action buttons.
 * @param {string} checkStatus - Current status of the system check
 * @param {boolean} isStandaloneChecker - Whether in standalone checker mode
 * @param {string[]} errors - Array of error messages
 * @param {Function} goToPage - Function to navigate to a different page
 * @param {Function} runSystemCheck - Function to run the system check
 * @param {Function} handleJoinMeeting - Function to handle joining the meeting
 * @param {boolean} isJoinInProgress - Whether the join process is in progress
 * @returns {JSX.Element} The footer component with action buttons
 */
var SystemCheckPageFooter = exports.SystemCheckPageFooter = function SystemCheckPageFooter(_ref) {
  var checkStatus = _ref.checkStatus,
    isStandaloneChecker = _ref.isStandaloneChecker,
    errors = _ref.errors,
    goToPage = _ref.goToPage,
    runSystemCheck = _ref.runSystemCheck,
    handleJoinMeeting = _ref.handleJoinMeeting,
    isJoinInProgress = _ref.isJoinInProgress;
  var checkInProgress = checkStatus === _constants.JOIN_PAGE_STATUS.IN_PROGRESS;
  var hasErrors = errors.length > 0 && !checkInProgress;
  var browserBlock = checkStatus === _constants.JOIN_PAGE_STATUS.BROWSER_BLOCK;
  var isJoinButtonDisabled = hasErrors || checkInProgress || browserBlock || isStandaloneChecker || isJoinInProgress;
  var goToSettingsPage = function goToSettingsPage() {
    return goToPage(_constants.JOIN_PAGE.SETTINGS);
  };
  var joinMeeting = (0, _react.useCallback)((0, _underscore.debounce)( /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.prev = 0;
          _context.next = 3;
          return handleJoinMeeting();
        case 3:
          _context.next = 8;
          break;
        case 5:
          _context.prev = 5;
          _context.t0 = _context["catch"](0);
          LOG.error('Join meeting failed', {
            error: _context.t0
          });
        case 8:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[0, 5]]);
  })), 2000, true), [handleJoinMeeting]);
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_.Button, {
    onClick: goToSettingsPage,
    color: "primary",
    variant: "link",
    disabled: checkInProgress,
    "data-testid": "back_button"
  }, "Back"), /*#__PURE__*/_react["default"].createElement(_.Button, {
    "data-testid": "run-test-button",
    disabled: checkInProgress,
    onClick: runSystemCheck,
    color: "outline"
  }, "Run Test"), /*#__PURE__*/_react["default"].createElement(_.Button, {
    "data-testid": "join-button",
    disabled: isJoinButtonDisabled,
    onClick: joinMeeting,
    color: "primary"
  }, "Join"));
};
SystemCheckPageFooter.propTypes = {
  checkStatus: _propTypes.string.isRequired,
  isStandaloneChecker: _propTypes.bool.isRequired,
  errors: (0, _propTypes.arrayOf)(_propTypes.string).isRequired,
  goToPage: _propTypes.func.isRequired,
  runSystemCheck: _propTypes.func.isRequired,
  handleJoinMeeting: _propTypes.func.isRequired
};